import { ITableDto, ITableFilter } from "../models/table";
import { getAuthorizationProperties } from "./authorizationHelper";

export async function createTable(table: ITableDto) {
    const response = await fetch(`/api/tables`, {
        method: "POST",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
        body: JSON.stringify(table),
    });

    return response.json();
}

export async function editTable(dto: ITableDto) {
    return await fetch("/api/tables", {
        method: "PATCH",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
        body: JSON.stringify(dto),
    });
}

export async function getTables(filter: ITableFilter, page: number, items: number) {
    const params = new URLSearchParams({ page: page.toString(), items: items.toString() });
    Object.entries(filter).forEach(x => {
        if (x[1] !== undefined && x[1] !== null && x[1] !== "") {
            params.append(x[0], x[1]);
        }
    });
    return await fetch("/api/tables?" + params.toString(), {
        method: "GET",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
    }).then(res => {
        if (res.ok) {
            return res.json();
        }
        throw Error;
    });
}

export async function getDevelopmentTables() {
    return await fetch("/api/tables/development", {
        method: "GET",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
    }).then(res => {
        if (res.ok) {
            return res.json();
        }
        throw Error;
    });
}

export async function bulkDeleteTables(
    filter: ITableFilter,
    selectedTable: string[],
    withFilter: boolean
) {
    const params = new URLSearchParams();

    if (withFilter) {
        Object.entries(filter).forEach(x => {
            if (x[1] !== undefined && x[1] !== null && x[1] !== "") {
                params.append(x[0], x[1]);
            }
        });
    } else {
        selectedTable.forEach(x => {
            params.append("selectedTables", x);
        });
    }

    return await fetch("/api/tables/bulk?" + params.toString(), {
        method: "DELETE",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
    }).then(res => {
        if (!res.ok) {
            return Promise.reject();
        }

        return Promise.resolve();
    });
}

export async function deleteTable(guid: string): Promise<boolean> {
    const response = await fetch(`/api/tables/${guid}`, {
        method: "DELETE",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
    });
    return response.ok;
}

export async function getTablesData(tableGuids: string[]): Promise<Record<string, string[][]>> {
    let params = new URLSearchParams();
    tableGuids.forEach(x => {
        params.append("guids", x);
    });
    return await fetch(`/api/tables/data/?${params.toString()}`, {
        method: "GET",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
    }).then(res => {
        return res.json();
    });
}

export async function publishTable(guid: string, isPublish: boolean) {
    return await fetch(`/api/tables/${guid}/publish?isPublish=${isPublish}`, {
        method: "PATCH",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
    });
}
